<template>
  <div class="w-full h-full bg-mist flex flex-col rounded overflow-hidden text-left" :class="{ 'md:grid md:items-center md:grid-cols-2': isPromoted }">
    <!-- MEDIA (two up, desktop) -->
    <div class="aspect-3/2 relative z-10 bg-black text-white hidden cursor-pointer" :class="{ 'md:block': isPromoted }" @click="useOpenPreview(restaurant.id, meal.id)">
      <AtomImage :src="imageUrl" :alt="`${meal?.name} - ${restaurant?.name}`" />
    </div>
    <div class="w-full" :class="{ 'md:col-start-2': isPromoted }">
      <div class="relative z-10 cursor-pointer" @click="useOpenPreview(restaurant.id, meal.id)">
        <!-- MEDIA (default) -->
        <div class="aspect-video relative z-10 bg-black text-white text-xs" :class="{ 'md:hidden': isPromoted }">
          <div class="absolute bottom-0 left-0 top-1/2 w-full bg-gradient-to-t from-black"></div>
          <AtomImage :src="imageUrl" :alt="`${meal?.name} - ${restaurant?.name}`" />
        </div>
        <div class="p-3 absolute z-20 bottom-0 left-0 text-white" :class="{ 'md:relative md:text-black': isPromoted, 'md:px-6': isPromoted, 'md:px-4': isFeatured }">
          <div class="grid gap-2">
            <div v-if="date" class="w-12 bg-sky text-ocean text-center py-2 rounded leading-tight">
              <p class="font-bold">{{ dayjs(date).format('D') }}</p>
              <p class="text-xs">{{ dayjs(date).format('MMM') }}</p>
            </div>
            <h2 class="leading-tight text-xl line-clamp-1" :class="{ 'font-bold': !isPromoted && !isFeatured, 'font-heading font-medium lg:text-3xl xl:text-4xl md:line-clamp-none': isPromoted, 'font-heading font-medium lg:text-2xl xl:text-3xl': isFeatured }" v-html="meal.name" />
            <div class="flex items-center gap-4 text-sm" :class="{ 'md:text-[#888888]': isPromoted }">
              <div class="flex items-center gap-2" v-if="meal.minAmount && meal.maxAmount">
                <AtomIcon name="users" class="w-4" />
                <div v-html="usePrettyAmountRange(meal.minAmount, meal.maxAmount)" />
              </div>
              <div class="flex items-center gap-2" v-if="meal.startTime && meal.endTime">
                <AtomIcon name="clock" class="w-4" />
                <div v-html="[mealTime, mealWeekday].join(' ')" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-3 grid gap-3" :class="{ 'md:px-6': isPromoted, 'md:px-4': isFeatured }">
        <AtomRestaurantLocation 
          @click="useOpenPreview(restaurant.id, meal.id)"
          class="cursor-pointer"
          :name="restaurant.name" 
          :address="restaurant.address"
        />
        <div class="flex items-center gap-3 text-sm max-w-sm" v-if="restaurant?.id">
          <button class="button-coral flex-1" @click="useOpenWidget(restaurant.hash, meal.id)">
            {{ $t('shared.bookTable') }}
          </button>
          <button class="button-sand-outline xl:w-32" @click="useOpenPreview(restaurant.id, meal.id)">
            <div class="flex items-center justify-center gap-2">
              <AtomIcon name="circle-info" />
              {{ $t('shared.info') }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const dayjs = useDayjs()

const props = defineProps({
  meal: {
    type: Object,
    default: () => {}
  },
  restaurant: {
    type: Object,
    default: () => {}
  },
  date: {
    type: String,
    default: ''
  },
  style: {
    type: String,
    default: () => ''
  }
})

// Grep restaurant and image url
const restaurant = props.meal?.restaurant

// Check style
const isPromoted = props.style === 'promoted'
const isFeatured = props.style === 'featured'

// // Get meal dates for multiple days
// const mealDate = computed(() => (props.meal.startDate !== props.meal.endDate
//   ? `${props.meal.startDate} - ${props.meal.endDate}`
//   : dayjs((props.meal.nextDates[0] || props.meal.startDate)).format('dddd D MMM') ))

// Get custom image or restaurant cover
const imageUrl = props.meal?.image || useCloudinaryImage(restaurant.cover, 600, 400)

// Get custom time and day for meal
const mealTime = usePrettyTimeRange(props.meal.startTime, props.meal.endTime)
const mealWeekday = dayjs(props.date).format('dddd')
</script>

<style lang="scss" scoped>

</style>